import Vue from 'vue'
// import Firebase from 'firebase/app'
import { ActionContext } from 'vuex'
import { RootState } from '@/types/store'
import { id } from '@/types/models'
import { DocumentChange, QuerySnapshot } from 'firebase/firestore'

interface GenericState<T> {
  data: Array<T>
}

type GenericContext<T> = ActionContext<GenericState<T>, RootState>

interface HasIdInterface {
  id: id
}

const findIndexById = <T extends HasIdInterface>(item: T, id: id): boolean =>
  item.id === id

export const change = <T extends HasIdInterface>(
  state: GenericState<T>,
  // { newIndex, oldIndex, doc, type }: Firebase.firestore.DocumentChange,
  { doc, type }: DocumentChange,
  findIndex = findIndexById
) => {
  // const storeIndex = type === 'added' ? -1 : state.data.findIndex((item: T) => findIndex<T>(item, doc.id))
  const storeIndex =
    type === 'added'
      ? -1
      : state.data.findIndex((item: T) => findIndex<T>(item, doc.id))
  // if (storeIndex !== newIndex)
  // console.log('change', storeIndex, newIndex, oldIndex, doc, type, doc.data())
  if (type === 'added') {
    // state.data.splice(newIndex, 0, doc.data())
    state.data.push(doc.data() as T)
  } else if (type === 'modified') {
    // if (newIndex !== oldIndex) {
    //   // remove the old one and add new one
    //   // state.data.splice(oldIndex, 1)
    //   // state.data.splice(newIndex, 0, doc.data())
    // } else {
    // replace existing
    // Vue.set(state.data, newIndex, doc.data())
    Vue.set(state.data, storeIndex, doc.data() as T)
    // }
  } else if (type === 'removed') {
    // state.data.splice(oldIndex, 1)
    Vue.delete(state.data, storeIndex)
  }
  // console.log(type, doc.data().constructor.name, doc.data())
}

const bindCollections = <T>(
  { dispatch }: GenericContext<T>,
  { doc, type }: DocumentChange
) => {
  const item = doc.data()
  if (
    type === 'added' &&
    item.collections() &&
    Object.keys(item.collections()).length > 0
  ) {
    // console.log(item.constructor.name, 'binding collections', item.collections(), doc.id)
    // return Promise.all(item.collections.map((col: string) => dispatch(`${col}/bind`, item.id)))
    return Promise.all(
      Object.entries(item.collections()).map(([mutation, payload]) =>
        dispatch(mutation, payload)
      )
    )
  } else if (type === 'modified') {
    // TODO: if keys are different, unbind from old child collections and bind to new child collections
    // console.log('modified', doc.id, item)
  } else if (type === 'removed') {
    // TODO: unbind from child collections
    // console.log('removed', doc.id)
  }
}

export const onSnapshot = <T>(
  context: GenericContext<T>,
  ref: QuerySnapshot
) => {
  return ref.docChanges().forEach((change: DocumentChange) => {
    context.commit('change', change) // commit change to store
    bindCollections(context, change) // bind all child collections
  })
}

// export { change, onSnapshot }
